import { useState } from 'react';

const useImageOverlay = (data, selectedPhotoID, isLoopy, isQuestionsAndAnswerPhotos, question, answer) => {
  const values = [];
  let imageNumber = 0;
  let map;
  map = {};

  if (isQuestionsAndAnswerPhotos) {
    data?.forEach((photo) => {
      const review = {
        Question: question,
        ReviewText: answer,
        Photos: data
      };
      imageNumber += 1;
      map[photo.Id] = { value: { review, photo, imageNumber } };
      values.push(map[photo.Id]);
    }, {});
  } else {
    map = data?.Results?.reduce((acc, review, index) => {
      review?.Photos?.forEach((photo) => {
        imageNumber += 1;
        acc[photo.Id] = { value: { review, photo, imageNumber }, index };
        values.push(acc[photo.Id]);
      });
      return acc;
    }, {});
  }

  const tail = values.reduce((acc, node) => {
    const currentNode = node;
    currentNode.previous = acc;
    return currentNode;
  }, null);

  const head = values.reduceRight((acc, node) => {
    const currentNode = node;
    currentNode.next = acc;
    return currentNode;
  }, null);

  if (isLoopy === true) {
    tail.next = head;
    head.previous = tail;
  }

  const [selected, setSelected] = useState(map[selectedPhotoID]);

  const selectImageByID = (id) => {
    if (map[id]) {
      setSelected(map[id]);
    }
  };
  const selectNext = () => {
    if (selected?.next) {
      setSelected(map[data?.Results[selected.index + 1].Photos[0].Id]);
    }
  };
  const selectPrevious = () => {
    if (selected?.previous) {
      setSelected(map[data?.Results[selected.index - 1].Photos[0].Id]);
    }
  };

  const customerResultIndex = !isQuestionsAndAnswerPhotos ? selected?.index : selected?.imageNumber;

  return {
    hasNextImage: !!selected?.next,
    hasPreviousImage: !!selected?.previous,
    selected: selected?.value,
    selectImageByID,
    selectNext,
    selectPrevious,
    customerResultIndex: customerResultIndex || 0,
    Results: data?.Results || data
  };
};

export { useImageOverlay };
